module.exports = __webpack_public_path__ + "img/education.f0702079.png";